import { render } from "./Auto.vue?vue&type=template&id=1f1eb7f4"
import script from "./Auto.vue?vue&type=script&lang=js"
export * from "./Auto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__